import React from 'react';
import Empresa from '../../../../../entities/Common/Empresa';
import Pagamento from '../../../../../entities/Common/Pagamento';
import Item from './Item'

import {
    Button,
    ListGroupItem,
    ListGroup,
    Row,
} from "reactstrap";

// import { Container } from './styles';

// Propriedades do meu componente
type Props = {
    // Lista de sites
    pagamentos: Array<Pagamento>,
    empresa: Empresa,
    // Método para passar notificações para o usuário
    notify(type: string, msg: string): void,
    reLoad(): void
}
// Adicionando as propriedades criadas acima
const List: React.FC<Props> = ({
    pagamentos,
    empresa,
    notify,
    reLoad
}) => {




    return (
        <ListGroup
            className="mt-4"
        >
            {
                //"map" percorre cada item da lista de pagamentos
                pagamentos.map((item, index) => (
                    <Item
                        empresa={empresa}
                        pagamento={item}
                        notify={notify}
                        onDeleted={reLoad}
                    />
                ))
            }
        </ListGroup>
    );
}

export default List;